import { singleton } from "tsyringe";
import ChoiceRequestResource from "common/resources/Project/Config/Choice/ChoiceRequestResource";
import { createFormData } from "utils/FormData";
import BaseQuestionIdApi from "./BaseQuestionIdApi";

@singleton()
export default class ChoiceApi extends BaseQuestionIdApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/choices`;
	}

	public async downloadFile(projectId: string, questionId: string, choiceId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId, questionId })}/${choiceId}/image`);
	}

	public async create(projectId: string, questionId: string, data: ChoiceRequestResource, file?: File): Promise<void> {
		const formData = createFormData(data);
		if (file) formData.append("file", file);

		return this.postRequestFormdata(`${this.getBaseUrl({ projectId, questionId })}`, formData);
	}

	public async update(projectId: string, questionId: string, choiceId: string, data: ChoiceRequestResource, file?: File): Promise<void> {
		const formData = createFormData(data);
		if (file) formData.append("file", file);

		return this.putRequestFormdata(`${this.getBaseUrl({ projectId, questionId })}/${choiceId}`, formData);
	}

	public async delete(projectId: string, questionId: string, choiceId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, questionId })}/${choiceId}`);
	}
}
